export default {
  article_details: "Detalles del Artículo",
  asset_details: "Detalles del Activo",
  assign_amount: "Asignar Cantidad",
  detailView: "Vista Detallada",
  new_customer_request: "Nueva Solicitud Personalizada",
  request_details: "Detalles de la Solicitud",
  generalInfo: "Información General",
  currentMetrics: "Métricas Actuales",
  technicalData: "Datos Técnicos",
  systemInfo: "Información del Sistema",
  assignedTo: "Asignado a",
};
